import { Button, Form, InputPassword } from '@seiue/ui'
import { Alert } from 'antd'
import { RuleObject } from 'antd/es/form'
import { StoreValue } from 'antd/es/form/interface'
import { useSetAtom } from 'jotai'
import React from 'react'
import styled from 'styled-components'

import { validatePassword } from 'packages/utils'

import { hasOpenedModifyPasswordAtom } from '@/App/Layout/atoms'

/**
 * 修改密码弹窗
 *
 * @param param - 参数
 * @param param.hide - 隐藏弹窗
 * @param param.onOk - 确认
 * @param param.tips - 提示
 * @returns React.ReactNode
 */
export const ChangePassword: React.FC<{
  hide: () => void
  onOk: (password: string, repeatPassword: string) => void
  tips?: boolean
}> = ({ hide, onOk, tips }) => {
  const setHasOpenedModifyPassword = useSetAtom(hasOpenedModifyPasswordAtom)
  const [form] = Form.useForm()
  const validateConfirmPassword = (
    rule: RuleObject,
    value: StoreValue,
    callback: (error?: string) => void
  ) => {
    if (!value) {
      callback('请确认密码')
    }
    if (form.getFieldValue('password') !== value) {
      callback('两次输入密码不一致')
    }
    callback()
  }
  return (
    <>
      <FormWrapper>
        <Form
          form={form}
          layout="vertical"
        >
          {tips ? (
            <Alert
              type="warning"
              showIcon={true}
              message="为了您的账号更加安全，建议及时修改初始密码"
              style={{
                borderRadius: '8px',
                marginBottom: '20px',
              }}
            />
          ) : null}
          <Form.Item
            label="新密码"
            name="password"
            rules={[
              {
                validator: validatePassword,
              },
            ]}
          >
            <InputPassword placeholder="请输入新密码" />
          </Form.Item>
          <Form.Item
            label="确定密码"
            name="repeatPassword"
            rules={[
              {
                validator: validateConfirmPassword,
              },
            ]}
          >
            <InputPassword placeholder="请重新输入新密码" />
          </Form.Item>
        </Form>
      </FormWrapper>
      <ButtonWrapper>
        <Button
          onClick={() => {
            setHasOpenedModifyPassword(true)
            hide()
          }}
        >
          取消
        </Button>
        <Button
          type="primary"
          onClick={() => {
            form.validateFields().then((value) => {
              onOk(value.password, value.repeatPassword)
            })
            setHasOpenedModifyPassword(true)
          }}
        >
          确定修改
        </Button>
      </ButtonWrapper>
    </>
  )
}

const FormWrapper = styled.div`
  padding: 20px 20px 0 20px;
  .ant-form-item-control-input-content {
    & > div {
      width: 100%;
    }
  }
`

const ButtonWrapper = styled.div`
  width: 100%;
  padding: 12px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  box-shadow: inset 0px 1px 0px 0px #e5e6e8;
`
